<template>
  <div>
    <template v-if="!isWxGamePlayable">
      <el-form-item label="朋友圈文字链" prop="components.text_link">
        <div class="components-box">
          <!-- 朋友圈文字链与礼包组件互斥，只能开启一个 -->
          <el-switch
            v-model="creativeForm.components.text_link.switch"
            class="components-switch"
            :disabled="componentsDisabled.textLink"
            title="开启礼包码、图文链接时，朋友圈文字链禁用"
          ></el-switch>

          <template v-if="creativeForm.components.text_link.switch">
            <div class="components-row">
              <label class="label">文字链文案</label>
              <el-select v-model="creativeForm.components.text_link.value" placeholder="">
                <el-option v-for="text in linkNameTypes" :key="text.value" :label="text.label" :value="text.value"> </el-option>
              </el-select>
            </div>

            <div class="components-row">
              <label class="label">跳转落地页</label>
              <PageType v-model="creativeForm.components.text_link.page_type" :platform="planForm.ch_platform_id"></PageType>
            </div>
          </template>
        </div>
      </el-form-item>
    </template>

    <template v-if="!isManualCreative">
      <el-form-item label="行动按钮" prop="components.action_button">
        <div class="components-box">
          <el-switch v-model="creativeForm.components.action_button.switch" class="components-switch" disabled></el-switch>
          <div class="components-row" v-if="creativeForm.components.action_button.switch">
            <label class="label">按钮文案</label>
            <el-select v-model="creativeForm.components.action_button.value" placeholder="">
              <el-option v-for="item in linkNameTypes" :key="item.value" :label="item.label" :value="item.label"> </el-option>
            </el-select>
          </div>
        </div>
      </el-form-item>

      <el-form-item label="小游戏试玩" prop="components.wxgame_playable_component">
        <div class="components-box">
          <el-switch
            v-model="creativeForm.components.wxgame_playable_component.switch"
            :disabled="componentsDisabled.wxgamePlayable"
            class="components-switch"
          ></el-switch>

          <template v-if="creativeForm.components.wxgame_playable_component.switch">
            <div class="components-row">
              <label class="label">开启方式</label>
              <el-checkbox-group v-model="creativeForm.components.wxgame_playable_component.wxgame_playable_page_trigger_types">
                <el-checkbox :label="WXGAME_PLAYABLE_TRIGGER_TYPE.CARD" disabled>图文链接</el-checkbox>
                <el-checkbox :label="WXGAME_PLAYABLE_TRIGGER_TYPE.MASK">引导蒙层</el-checkbox>
              </el-checkbox-group>
            </div>

            <div class="components-row">
              <label class="label">图片（选填）</label>
              <slot name="wxgameplayableimage"></slot>
            </div>

            <div class="components-row">
              <label class="label">文案</label>
              <el-input
                v-model="creativeForm.components.wxgame_playable_component.wxgame_playable_page_card_link_description"
                placeholder="限制16个字符，中文占2个字符，英文占1个"
              >
                <template #suffix>{{ wxgamePlayableDesc.componentCardDescCount }}/16</template>
              </el-input>
            </div>

            <div class="components-row">
              <label class="label">按钮文案</label>
              <el-select style="width: 100%" v-model="creativeForm.components.wxgame_playable_component.wxgame_playable_page_trigger_text">
                <el-option v-for="(text, index) in LINK_NAME_TYPE_WXGAME_PLAYABLE" :key="index" :label="text" :value="text"> </el-option>
              </el-select>
            </div>

            <div class="components-row">
              <label class="label">试玩页</label>
              <WxgamePlayableSelector
                style="width: 100%"
                v-model="creativeForm.components.wxgame_playable_component.wxgame_playable_page_path"
                :list="wxgamePlayableList"
              ></WxgamePlayableSelector>
            </div>

            <div class="components-row">
              <label class="label">结束页</label>
              <slot name="wxgameplayableendimage"></slot>
            </div>

            <div class="components-row">
              <label class="label">结束页文案</label>
              <el-input
                v-model="creativeForm.components.wxgame_playable_component.wxgame_playable_page_end_desc"
                placeholder="请输入结束页文案，限制16个字符，中文占2个字符，英文占1个"
              >
                <template #suffix>{{ wxgamePlayableDesc.componentEndDescCount }}/16</template>
              </el-input>
            </div>

            <WxgamePlayableEndTime
              v-model="creativeForm.components.wxgame_playable_component.wxgame_playable_page_end_time_type"
            ></WxgamePlayableEndTime>
          </template>
        </div>
      </el-form-item>

      <el-form-item label="图文链接" prop="components.mini_card_link">
        <div class="components-box">
          <el-switch
            v-model="creativeForm.components.mini_card_link.switch"
            class="components-switch"
            title="开启礼包码、朋友圈文字链时图文链接禁用"
            :disabled="componentsDisabled.miniCardLink"
          ></el-switch>
          <template v-if="creativeForm.components.mini_card_link.switch">
            <div class="components-row">
              <label class="label">创意图片（选填）</label>
              <slot name="minicardimage"></slot>
            </div>

            <div class="components-row">
              <label class="label">文案</label>
              <DynamicWordsInput
                ref="miniCardLinkDescriptionRef"
                :reg-exp="emojiRegExp"
                v-model="creativeForm.components.mini_card_link.mini_card_link_description"
              >
                <el-input
                  ref="miniCardLinkDescriptionInputRef"
                  style="width: 420px"
                  v-model="creativeForm.components.mini_card_link.mini_card_link_description"
                >
                  <template #append>
                    <emoji-input-btns>
                      <template #emoji-icon><gdt-emojis @select="(e) => insertMiniCardLinkDescText(e.label)"></gdt-emojis></template>
                    </emoji-input-btns>
                  </template>
                </el-input>
              </DynamicWordsInput>
            </div>

            <div class="components-row">
              <label class="label">按钮文案</label>
              <el-select v-model="creativeForm.components.mini_card_link.mini_card_link_button_text">
                <el-option v-for="item in linkNameTypes" :key="item.value" :label="item.label" :value="item.label"> </el-option>
              </el-select>
            </div>

            <div class="components-row">
              <label class="label">跳转落地页</label>
              <PageType v-model="creativeForm.components.mini_card_link.page_type" :platform="planForm.ch_platform_id"></PageType>
            </div>
          </template>
        </div>
      </el-form-item>

      <el-form-item label="礼包组件" prop="components.app_gift_pack_code">
        <div class="components-box">
          <!-- 朋友圈文字链与礼包组件互斥，只能开启一个 -->
          <el-switch
            v-model="creativeForm.components.app_gift_pack_code.switch"
            class="components-switch"
            :disabled="componentsDisabled.appGiftPackCode"
            title="开启朋友圈文字链、图文链接时，礼包码禁用"
          ></el-switch>

          <template v-if="creativeForm.components.app_gift_pack_code.switch">
            <div class="components-row">
              <label class="label">礼包描述</label>
              <el-input v-model="creativeForm.components.app_gift_pack_code.code" placeholder="请输入礼包描述"></el-input>
            </div>

            <div class="components-row">
              <label class="label">礼包码</label>
              <el-input v-model="creativeForm.components.app_gift_pack_code.description" placeholder="请输入礼包码"></el-input>
            </div>
          </template>
        </div>
      </el-form-item>

      <el-form-item label="标签">
        <div class="components-box">
          <div class="components-row">
            <label class="label">&ensp;</label>
            <div>
              <el-tag style="margin-right: 10px" v-for="label in creativeForm.components.label" :key="label.id">{{ label.name }}</el-tag>
              <slot name="labelbtns"></slot>
            </div>
          </div>
        </div>
      </el-form-item>

      <el-form-item label="浮层卡片" prop="components.floating_zone">
        <div class="components-box">
          <el-switch v-model="creativeForm.components.floating_zone.floating_zone_switch" class="components-switch"></el-switch>

          <template v-if="creativeForm.components.floating_zone.floating_zone_switch">
            <div class="components-row">
              <label class="label">创意图片</label>
              <slot name="floatingzoneimage"></slot>
            </div>

            <div class="components-row" prop="components.floating_zone">
              <label class="label">文案</label>
              <el-input v-model="creativeForm.components.floating_zone.floating_zone_name" placeholder="请输入文案（1-10字）"></el-input>
            </div>

            <div class="components-row">
              <label class="label">文案二</label>
              <el-input
                :class="{ 'override-not-reqiured-error': !creativeForm.components.floating_zone.floating_zone_desc }"
                v-model="creativeForm.components.floating_zone.floating_zone_desc"
                placeholder="请输入文案（1-14字）"
              ></el-input>
            </div>

            <div class="components-row">
              <label class="label">按钮文案</label>
              <el-select
                :class="{ 'override-not-reqiured-error': !creativeForm.components.floating_zone.floating_zone_button_text }"
                v-model="creativeForm.components.floating_zone.floating_zone_button_text"
                placeholder=""
              >
                <el-option v-for="item in linkNameTypes" :key="item.value" :label="item.label" :value="item.label"> </el-option>
              </el-select>
            </div>
          </template>
        </div>
      </el-form-item>

      <el-form-item label="弹幕" prop="components.barrage">
        <div class="components-box">
          <div class="components-row">
            <label class="label">（{{ creativeForm.components.barrage.length }}/20）</label>
            <div>
              <el-select
                style="width: 420px"
                multiple
                :multiple-limit="20"
                filterable
                v-model="creativeForm.components.barrage"
                value-key="id"
              >
                <el-option v-for="item in barrageList" :key="item.id" :label="item.text" :value="item"> </el-option>
              </el-select>

              <el-button type="text" @click="onBarrageClear">&ensp;清空</el-button>
            </div>
          </div>
        </div>
      </el-form-item>
    </template>

    <el-form-item label="数据外显" prop="components.show_data">
      <div class="components-box">
        <el-switch v-model="creativeForm.components.show_data.switch" class="components-switch"></el-switch>
        <div class="components-row" v-if="creativeForm.components.show_data.switch">
          <label class="label">数据类型</label>

          <el-radio-group v-model="creativeForm.components.show_data.conversion_data_type">
            <el-radio-button ghost :label="CONVERSION_DATA.ADMETRIC"> 转化数据量 </el-radio-button>
            <el-radio-button ghost :label="CONVERSION_DATA.APP_DOWNLOAD"> 应用下载量 </el-radio-button>
          </el-radio-group>
        </div>

        <div
          class="components-row"
          v-if="
            creativeForm.components.show_data.switch && creativeForm.components.show_data.conversion_data_type === CONVERSION_DATA.ADMETRIC
          "
        >
          <label class="label">转化行为</label>
          <el-radio-group
            v-model="creativeForm.components.show_data.conversion_target_type"
            v-if="planForm.ch_platform_id === PLATFORM.MINIGAME"
          >
            <el-radio-button v-for="target in MINIGAME_CONVERSION_TARGET_LIST" :key="target.value" ghost :label="target.value">
              {{ target.label }}
            </el-radio-button>
          </el-radio-group>

          <el-radio-group v-else v-model="creativeForm.components.show_data.conversion_target_type">
            <el-radio-button v-for="target in APP_CONVERSION_TARGET_LIST" :key="target.value" ghost :label="target.value">
              {{ target.label }}
            </el-radio-button>
          </el-radio-group>
        </div>
      </div>
    </el-form-item>

    <!-- 试玩素材的配置项 -->
    <template v-if="isWxGamePlayable && pageStates.isTemplateCreate">
      <el-form-item label="试玩素材" prop="components.wxgame_playable_material_config">
        <div class="components-box">
          <div class="components-row">
            <label class="label">账号</label>
            <el-select
              v-model="creativeForm.components.wxgame_playable_material_config.account.adAccount"
              @change="onWxgamePlayableAccountChange"
              placeholder="请选择账号"
            >
              <el-option v-for="acc in accounts" :key="acc.adAccount" :label="acc.adAccount" :value="acc.adAccount"> </el-option>
            </el-select>
          </div>

          <div class="components-row">
            <label class="label">试玩页</label>
            <WxgamePlayableSelector
              style="width: 100%"
              v-model="creativeForm.components.wxgame_playable_material_config.playable_page_path"
              :list="wxgamePlayableList"
              @change="onWxGamePlayableMaterialPagePathChange"
            ></WxgamePlayableSelector>
          </div>

          <WxgamePlayableEndTime
            v-model="creativeForm.components.wxgame_playable_material_config.wxgame_playable_page_end_time_type"
          ></WxgamePlayableEndTime>
        </div>
      </el-form-item>
    </template>

    <!-- 新建广告时不显示，批量复制、批量修改、单条修改广告创意时显示。 -->
    <template v-if="isWxGamePlayable && (pageStates.isDuplicate || pageStates.isModify || pageStates.isUpdateCreative)">
      <el-form-item label="试玩页结束页" prop="components.wxgame_playable">
        <div class="components-box">
          <div class="components-row">
            <label class="label">试玩页</label>

            <WxgamePlayableSelector
              style="width: 420px"
              v-model="creativeForm.components.wxgame_playable_page.wxgame_playable_page_path"
              :list="wxgamePlayableList"
            ></WxgamePlayableSelector>
          </div>
        </div>
      </el-form-item>

      <el-form-item label="试玩结束页封面图" prop="components.wxgame_playable_page">
        <div class="components-box">
          <el-switch
            v-model="creativeForm.components.wxgame_playable_page.wxgame_playable_page_switch"
            disabled
            class="components-switch"
            title="「激励浏览」场景下,「小游戏试玩页」 必须开启"
          ></el-switch>

          <template v-if="creativeForm.components.wxgame_playable_page.wxgame_playable_page_switch">
            <div class="components-row">
              <label class="label">试玩结束页封面图</label>
              <slot name="wxgameplayable"></slot>
            </div>

            <div class="components-row">
              <label class="label">结束页文案</label>
              <el-input
                v-model="creativeForm.components.wxgame_playable_page.wxgame_playable_page_end_desc"
                placeholder="限制20个字符，中文占2个字符，英文占1个"
              >
                <template #suffix>{{ wxgamePlayableDesc.customTextCount }}/20 </template>
              </el-input>
            </div>
          </template>
        </div>
      </el-form-item>
    </template>

    <template v-if="!isWxGamePlayable">
      <el-form-item label="首评回复" prop="components.social_skill">
        <div class="components-box">
          <div style="display: flex; align-items: center">
            <el-switch
              v-model="creativeForm.components.social_skill.social_skill_first_comment_switch"
              class="components-switch"
            ></el-switch>
          </div>
          <div class="components-row" v-if="creativeForm.components.social_skill.social_skill_first_comment_switch">
            <label class="label">回复内容</label>
            <DynamicWordsInput
              ref="commentRef"
              :reg-exp="emojiRegExp"
              v-model="creativeForm.components.social_skill.social_skill_first_comment"
            >
              <el-input
                ref="commentInputRef"
                style="width: 470px"
                placeholder="选填"
                show-word-limit
                maxlength="30"
                v-model="creativeForm.components.social_skill.social_skill_first_comment"
              >
                <template #append>
                  <emoji-input-btns>
                    <template #emoji-icon><gdt-emojis @select="(e) => insertText(e.label)"></gdt-emojis></template>
                    <template #hash-tag><span @click="insertText('#')">#</span></template>
                  </emoji-input-btns>
                </template>
              </el-input>
            </DynamicWordsInput>
          </div>
        </div>
      </el-form-item>
    </template>

    <template v-if="!isManualCreative">
      <el-form-item label="视频结束页" prop="components.end_page">
        <div class="components-box">
          <el-switch v-model="creativeForm.components.end_page.switch" class="components-switch"></el-switch>

          <template v-if="creativeForm.components.end_page.switch">
            <div class="components-row">
              <label class="label">视频结束页类型</label>
              <el-radio-group v-model="creativeForm.components.end_page.end_page_type">
                <el-radio-button ghost label="END_PAGE_AVATAR_NICKNAME_HIGHLIGHT"> 突出头像及昵称 </el-radio-button>
                <el-radio-button ghost label="END_PAGE_DESCRIPTION_HIGHLIGHT"> 突出文案 </el-radio-button>
              </el-radio-group>
            </div>

            <div class="components-row">
              <label class="label">结束页文案</label>
              <el-input v-model="creativeForm.components.end_page.end_page_desc" placeholder="请输入文案"></el-input>
            </div>
          </template>
        </div>
      </el-form-item>

      <el-form-item label="是否保存到视频号">
        <div class="components-box">
          <el-switch v-model="creativeForm.components.wechat_channels.finder_object_visibility" class="components-switch"></el-switch>
        </div>
      </el-form-item>
    </template>
  </div>
</template>
<script setup>
import { computed, inject, set } from 'vue'
import { getByteLen } from '@/common/js/utils'
import DynamicWordsInput from '@/components/dynamic-words-input'
import GdtEmojis from '@/components/gdt-emojis/index.vue'
import EmojiInputBtns from '../emoji-input/btns.vue'
import PageType from '../page-type/index.vue'
import WxgamePlayableSelector from './wxgame-playable-selector.vue'
import WxgamePlayableEndTime from './wxgame-playable-end-time.vue'

import {
  LINK_NAME_TYPE,
  LINK_NAME_TYPE_MINIGAME,
  LINK_NAME_TYPE_WXGAME_PLAYABLE,
  CONVERSION_DATA,
  MINIGAME_CONVERSION_TARGET_LIST,
  APP_CONVERSION_TARGET_LIST,
  WXGAME_PLAYABLE_TRIGGER_TYPE
} from '@/views/create/gdt/model/creative-const.js'
import { useGdtCreativeComputes } from '@/views/create/gdt/template/hooks/utils/creative.js'
import { useGdtTemplateUtils } from '@/views/create/gdt/template/hooks/utils/index.js'
import { PLATFORM } from '@/views/create/gdt/model/project-const.js'
import {
  emojiRegExp,
  useMiniCardLink,
  useBarrage,
  useFirstComment,
  useWxGamePlayableSelector
} from '@/views/create/gdt/template/hooks/useGdtCreativeForm.js'
const { getAdAccount } = inject('localStates')
const onWxGamePlayableMaterialPagePathChange = (val) => {
  const item = wxgamePlayableList.value.find((i) => i.playable_page_path === val)
  set(creativeForm.value.components.wxgame_playable_material_config, 'playable_item', item)
}

// eslint-disable-next-line
const props = defineProps({
  value: Object,
  planForm: Object,
  accounts: {
    type: Array,
    default: () => []
  }
})
// eslint-disable-next-line
const emits = defineEmits(['input'])
// const creativeForm = toRef(props, 'value')
const creativeForm = computed(() => props.value)
const planForm = computed(() => props.planForm)
const { componentsDisabled, isManualCreative, isWxGamePlayable } = useGdtCreativeComputes(creativeForm)
const { pageStates, platform } = useGdtTemplateUtils(planForm)
const linkNameTypes = computed(() => {
  return platform.value.isMiniGame ? LINK_NAME_TYPE_MINIGAME : LINK_NAME_TYPE
})

// 试玩
const { wxgamePlayableList, wxGameQueryAction } = useWxGamePlayableSelector(planForm, creativeForm, isWxGamePlayable)
const wxgamePlayableDesc = computed(() => {
  const { wxgame_playable_page_end_desc: desc } = creativeForm.value.components.wxgame_playable_page || {}
  const { wxgame_playable_page_card_link_description, wxgame_playable_page_end_desc: compDesc } =
    creativeForm.value.components.wxgame_playable_component || {}
  return {
    customTextCount: desc ? Math.ceil(getByteLen(desc)) : 0,
    componentEndDescCount: compDesc ? Math.ceil(getByteLen(compDesc)) : 0,
    componentCardDescCount: wxgame_playable_page_card_link_description
      ? Math.ceil(getByteLen(wxgame_playable_page_card_link_description))
      : 0
  }
})
wxGameQueryAction()

const onWxgamePlayableAccountChange = (acc) => {
  const { id } = props.accounts.find((i) => i.adAccount === acc)
  wxGameQueryAction(id)
}
// 图文链接
const { miniCardLinkDescriptionRef, miniCardLinkDescriptionInputRef, insertMiniCardLinkDescText } = useMiniCardLink(creativeForm)
// 首评回复
const { commentRef, commentInputRef, insertText } = useFirstComment(creativeForm)
// 弹幕
const { barrageList, onBarrageClear } = useBarrage(getAdAccount, creativeForm)
</script>
<style lang="scss" scoped>
.components-box {
  background: #f9f9f9;
  padding: 10px 10px 30px;
  border-radius: 10px;

  ::v-deep .components-switch {
    padding-right: 10px;
    justify-content: flex-end;
    width: 130px;
  }

  ::v-deep .el-input-group__append {
    background-color: #fff;
    padding: 0 5px;
  }

  .components-row {
    margin-bottom: 10px;
    display: flex;
    .label {
      padding-right: 10px;
      text-align: right;
      min-width: 130px;
      font-size: 14px;
    }
    // 同一个 el-form-item 里不需要校验的input 样式覆盖
    ::v-deep .override-not-reqiured-error input {
      border-color: #dcdfe6 !important;
    }
  }
}
</style>
